<template>
  <div class="product__meta-data">
    <template v-if="metaFieldsValue">
      <div v-html="metaFieldsValue"></div>
      <div>
        <div class="pt-sm hidden-md-up"></div>
        <div class="pt-md hidden-md-down"></div>
      </div>
      <ShopNowButton :section="{ text: 'Get Yours' }" />
    </template>
    <sib-skeleton-loading
      v-else-if="!productStore.product"
      height="8rem"
      width="100%"
    ></sib-skeleton-loading>
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import useProductStore from '@/store/product'
import ShopNowButton from './ShopNowButton.vue'

const props = withDefaults(defineProps<{ section: { key: string } }>(), {})
const productStore = useProductStore()

const METAFIELD_NAME_SPACE_CUSTOM = 'custom'

const metaFieldsValue = computed(() => {
  if (!props.section.key) return
  const metaFieldsData = productStore.product?.metafields?.find(
    (item) =>
      item &&
      item.namespace == METAFIELD_NAME_SPACE_CUSTOM &&
      item.key == props.section.key
  )
  if (!metaFieldsData) return
  return metaFieldsData.value
})
</script>
